import cn from "classnames";
import PanelTemplate from "components/shared/profile/panel";
import Select, { customStyles } from "components/shared/select";
import { logistTaskTypesEnum } from "helpers/enums";
import Tooltip from "rc-tooltip";
import React from "react";
import { applySettings, getSettings } from "sources/books/tasks";
import { config, initialState } from "./config";

class LogistTaskSettings extends PanelTemplate {
    state = {
        data: { settings: [] },
        isValid: true,
    };

    componentDidMount() {
        getSettings().then((data) => this.setState({ data: { settings: data }, initial: { ...data } }));
    }

    componentDidUpdate() {
        return undefined;
    }

    renderBody = () => {
        return (
            <>
                <table className="table table-sm">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Включено</th>
                            <th>Роль в заявке</th>
                            <th>Группа пользователей</th>
                            <th>Тип уведомления</th>
                            <th>Обязательный комментарий</th>
                            <th>Срок выполнения</th>
                        </tr>
                    </thead>
                    <tbody>{this.state.data.settings.map(this.renderItem)}</tbody>
                </table>
            </>
        );
    };

    renderItem = (item, i) => {
        const { editable } = this.props;
        const { config } = this.props.config.settings;
        const onChange = ({ name, value }) => {
            const newVal = this.state.data.settings.map((setting, index) => ({
                ...setting,
                ...(index === i ? { [name]: value } : {}),
            }));
            this.setState({ data: { settings: newVal } });
        };
        return (
            <tr key={i}>
                <td className="align-middle">{i + 1}</td>
                <td className="align-middle">
                    {this.renderCheckbox({
                        ...config.isActive,
                        disabled: !editable,
                        value: item.isActive,
                        onChange,
                        checkboxWrapCname: "m-0",
                    })}
                </td>
                <td>
                    <Select
                        {...config.bidRole}
                        disabled={!editable}
                        value={item.bidRole}
                        index={i}
                        onChange={({ value }) => onChange({ name: "bidRole", value })}
                        styles={{ ...customStyles, menu: (styles) => ({ ...styles, zIndex: 11, width: "200px" }) }}
                    />
                </td>
                <td>
                    <Select
                        {...config.groupId}
                        disabled={!editable}
                        value={item.groupId}
                        index={i}
                        onChange={({ value }) => onChange({ name: "groupId", value })}
                        styles={{ ...customStyles, menu: (styles) => ({ ...styles, zIndex: 11, width: "200px" }) }}
                    />
                </td>
                <td className="align-middle">{item.name}</td>
                <td className="align-middle">
                    {item.type === logistTaskTypesEnum.NotificationType &&
                        this.renderCheckbox({
                            ...config.commentRequired,
                            disabled: !editable,
                            value: item.commentRequired,
                            onChange,
                            checkboxWrapCname: "m-0",
                        })}
                </td>
                <td className="align-middle">
                    {item.type !== logistTaskTypesEnum.NotificationType && (
                        <Tooltip overlay={item.hoursBeforeDescription}>
                            <input
                                className="form-control form-control-xs"
                                disabled={!editable}
                                value={item.hoursBefore}
                                name={`${config.bidRole.inputProps.hoursBefore}_${i}`}
                                type="number"
                                step="1"
                                onChange={(e) => onChange({ name: "hoursBefore", value: e.target.value })}
                            />
                        </Tooltip>
                    )}
                </td>
            </tr>
        );
    };

    update = () => {
        const { data } = this.state;
        if (!this.isValidForm(data)) {
            return this.setState({ isValid: false });
        }
        return applySettings(data).then((res) => this.setState({ shouldUpdate: false, isValid: !!res }));
    };

    renderButton = () => {
        return (
            this.props.editable && (
                <div className="panel__row panel__row--button">
                    <div className="btn btn-brand btn-sm" onClick={this.update}>
                        Обновить
                    </div>
                </div>
            )
        );
    };

    render() {
        const cname = cn("card card-body mb-3", {
            "border-danger book-form__body--invalid": !this.state.isValid,
        });
        return (
            <div className={cname}>
                <h5 className="mb-4">Настройки автоматических задач логистам</h5>
                {this.renderBody()}
                {this.renderButton()}
            </div>
        );
    }
}

const ConfiguredPanel = (props) => (
    <LogistTaskSettings
        {...props}
        config={config}
        initialState={initialState}
        editable={props.roles.isTruckingOrganizationAdmin}
    />
);

export default ConfiguredPanel;
